export default __webpack_public_path__ + "static/media/PDR-2.2293950d.jpg";